import { render } from "./ErstInfoPop.vue?vue&type=template&id=4c3221e8"
import script from "./ErstInfoPop.vue?vue&type=script&lang=js"
export * from "./ErstInfoPop.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__